const Button = ({
    title,
    isDisabled = false,
    onClick,
    type = "button",
}: {
    title: string;
    isDisabled: boolean;
    onClick: () => void;
    type: "button" | "submit"
}) => {
    return <button 
        className={`mb-6 ${isDisabled ? "bg-gray-300" : "bg-black hover:bg-transparent hover:text-black"} text-white border p-2 rounded-lg h-[calc(60px)]  w-full`}
        type={type}
        disabled={isDisabled}
        onClick={onClick}>
        {title}
    </button>;
}

export default Button;